<div [ngClass]="{ 'grid': detailsStyle }">
  @if (detailsStyle) {
    <div class="label-detail">
      <span>{{ progressLabel }}</span>
    </div>
  }
  <div>
    <div class="progress-bar">
      <div class="progress" [ngStyle]="{ 'width': progressStyle + '%' }">

      </div>
    </div>
  </div>
  @if (!detailsStyle) {
    <div>
      <div class="label-message">
        <span>{{ progressLabel }}</span>
      </div>
    </div>
  }
</div>